import template from './userForm.html';
import controller from './userForm.controller';

export const userFormComponent = {
  name: 'userForm',
  restrict: 'E',
  bindings: {
    user: '=',
    form: '<',
    messages: '<',
    index: '<',
    removeable: '<',
    remove: '&',
    removeLabel: '<',
    isTinRequired: '<',
    hideEmail: '=',
  },
  template,
  controllerAs: 'vm',
  controller,
};



// WEBPACK FOOTER //
// ./src/app/common/ui/userForm/userForm.component.js